module.exports = __webpack_public_path__ + "static/media/checkin-check.52d6c407.png";